import {
  ComponentFactoryResolver,
  HostListener,
  ViewContainerRef,
  ElementRef,
  Component,
  OnInit,
  Type,
  Input,
  NgZone
} from '@angular/core';
import * as GoldenLayout from 'golden-layout';
import $ from 'jquery';
import { GlOnInit, GlOnResize } from './hooks';
import { GoldenLayoutService, IComponentInitCallbackFactory, IComponentInitCallback } from './golden-layout.service';
/**
 * @param {?} obj
 * @return {?}
 */
function isGlOnInit(obj: any): obj is GlOnInit {
  return typeof obj === 'object' && typeof obj.glOnInit === 'function';
}
/**
 * @param {?} obj
 * @return {?}
 */
function isGlOnResize(obj: any): obj is GlOnResize {
  return typeof obj === 'object' && obj && typeof obj.glOnResize === 'function';
}

const /** @type {?} */ COMPONENT_REF_KEY = '$componentRef';
export class GoldenLayoutComponent implements OnInit, IComponentInitCallbackFactory {
private goldenLayout: GoldenLayout;
/**
 * @param {?} glService
 * @param {?} el
 * @param {?} viewContainer
 * @param {?} componentFactoryResolver
 * @param {?} ngZone
 */
constructor(private glService: GoldenLayoutService,
private el: ElementRef,
private viewContainer: ViewContainerRef,
private componentFactoryResolver: ComponentFactoryResolver,
private ngZone: NgZone) {}
/**
 * @return {?}
 */
public ngOnInit(): void {
    this.goldenLayout = new GoldenLayout(
      this.glService.config.layout,
      $(this.el.nativeElement).find('.golden-layout-root'));

    // Register an event handler to destory the angular component on container destruction.
    this.goldenLayout.eventHub.on('itemDestroyed', (item: any) => {
      const /** @type {?} */ container = item.container;
      const /** @type {?} */ component = container && container[COMPONENT_REF_KEY];
      if (component) {
        component.destroy();
      }
    });

    // Register all golden-layout components.
    this.glService.registerComponents(this.goldenLayout, this);

    // Initialize the layout.
    this.goldenLayout.init();
  }
/**
 * @param {?} event
 * @return {?}
 */
public onResize(event: any): void {
    if (this.goldenLayout) {
      this.goldenLayout.updateSize();
    }
  }
/**
 * @param {?} componentType
 * @return {?}
 */
public createComponentInitCallback(componentType: Type<any>): IComponentInitCallback {
    return (container: GoldenLayout.Container, componentState: any) => {
      this.ngZone.run(() => {

        // Create an instance of the angular component.
        const /** @type {?} */ factory = this.componentFactoryResolver.resolveComponentFactory(componentType);
        const /** @type {?} */ componentRef = this.viewContainer.createComponent(factory);
        const /** @type {?} */ component = componentRef.instance;

        // If the coponent implements Dockable, then initialize it.
        if (isGlOnInit(component)) {
          component.glOnInit(this.goldenLayout.eventHub, componentState);
        }

        // Bind the new component to container's client DOM element.
        container.getElement().append($(componentRef.location.nativeElement));

        // Register an event hanlder to proxy the resize event.
        container.on('resize', (item: any) => {
          if (isGlOnResize(component)) {
            component.glOnResize();
          }
        });

        // Store a ref to the compoenentRef in the container to support destruction later on.
        ( /** @type {?} */((container as any)))[COMPONENT_REF_KEY] = componentRef;
      });
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'golden-layout-root',
  template: `<div class="golden-layout-root" style="width:100%;height:100%;"></div>`,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: GoldenLayoutService, },
{type: ElementRef, },
{type: ViewContainerRef, },
{type: ComponentFactoryResolver, },
{type: NgZone, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'onResize': [{ type: HostListener, args: ['window:resize', ['$event'], ] },],
};
}

function GoldenLayoutComponent_tsickle_Closure_declarations() {
/** @type {?} */
GoldenLayoutComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GoldenLayoutComponent.ctorParameters;
/** @type {?} */
GoldenLayoutComponent.propDecorators;
/** @type {?} */
GoldenLayoutComponent.prototype.goldenLayout;
/** @type {?} */
GoldenLayoutComponent.prototype.glService;
/** @type {?} */
GoldenLayoutComponent.prototype.el;
/** @type {?} */
GoldenLayoutComponent.prototype.viewContainer;
/** @type {?} */
GoldenLayoutComponent.prototype.componentFactoryResolver;
/** @type {?} */
GoldenLayoutComponent.prototype.ngZone;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
